import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6667 3.99998C10.6667 5.47274 9.47275 6.66665 8 6.66665C6.52724 6.66665 5.33333 5.47274 5.33333 3.99998C5.33333 2.52722 6.52724 1.33331 8 1.33331C9.47275 1.33331 10.6667 2.52722 10.6667 3.99998Z"
        fill={colorValue}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11 14.6666C9.90005 14.6666 9.35008 14.6666 9.00837 14.3249C8.66666 13.9832 8.66666 13.4333 8.66666 12.3333C8.66666 11.2334 8.66666 10.6834 9.00837 10.3417C9.35008 9.99998 9.90005 9.99998 11 9.99998C12.0999 9.99998 12.6499 9.99998 12.9916 10.3417C13.3333 10.6834 13.3333 11.2334 13.3333 12.3333C13.3333 13.4333 13.3333 13.9832 12.9916 14.3249C12.6499 14.6666 12.0999 14.6666 11 14.6666ZM12.312 11.8305C12.4639 11.6787 12.4639 11.4324 12.312 11.2806C12.1601 11.1287 11.9139 11.1287 11.762 11.2806L10.4815 12.5611L10.2379 12.3176C10.0861 12.1657 9.83984 12.1657 9.68797 12.3176C9.5361 12.4695 9.5361 12.7157 9.68797 12.8676L10.2065 13.3861C10.3584 13.5379 10.6046 13.5379 10.7565 13.3861L12.312 11.8305Z"
        fill={colorValue}
      />
      <path
        d="M10.2765 9.00491C9.60308 8.78947 8.82664 8.66665 8 8.66665C5.42267 8.66665 3.33333 9.86055 3.33333 11.3333C3.33333 12.7604 5.29496 13.9256 7.76142 13.9966C7.74331 13.9124 7.72934 13.8288 7.7183 13.7467C7.66652 13.3616 7.66659 12.891 7.66667 12.3906V12.276C7.66659 11.7756 7.66652 11.3051 7.7183 10.9199C7.77593 10.4913 7.91365 10.0222 8.30128 9.63457C8.6889 9.24695 9.15802 9.10922 9.58661 9.0516C9.79458 9.02364 10.0275 9.0108 10.2765 9.00491Z"
        fill={colorValue}
      />
    </svg>
  );
};
